export default __webpack_public_path__ + "assets/images/6e844022b9beaa70eeaff237d134937e.svg";